export function ReportFooter({ children }: { children: React.ReactNode }) {
  return (
    <footer className="hidden footer print:flex bg-background justify-between fixed bottom-0 left-0 w-full z-10 items-center mt-1 flex-row p-8">
      <span className="text-sm text-muted-foreground">{children}</span>
    </footer>
  );
}
